import {
  Button,
  Typography,
  Box,
  Grid,
  Checkbox,
  Snackbar,
  Alert,
  TextField,
  Select,
  Autocomplete,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
  Divider,
  CircularProgress,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Editor } from "@tinymce/tinymce-react";
import { useState, useEffect } from "react";
import Block from "../../../components/Block";
import CustomerSelect from "../../../components/AsyncSelects/CustomerSelect";
import AddIcon from "@mui/icons-material/Add";
// import AccountSelect from "../../../components/AsyncSelects/AccountSelect";
import CustomerCard from "./CustomerCard";
import { emailsReducer, EMAILS_INIT, REDUCER_ACTIONS } from "./config";
import AttachmentComponent from "./AttachmentComponent";
import { useReducer } from "react";

import { sendEmail, simulateRecipients } from "../../../distflowAPI/customersApi";
import AccountSelect from "../../../components/AsyncSelects/AccountSelect";
import AccountTypeSelect from "../../../components/AsyncSelects/AccountTypeSelect";
import TerritorySelect from "../../../components/AsyncSelects/TerritorySelect";
export default function EmailSend() {
  const [data, dispatch] = useReducer(emailsReducer, EMAILS_INIT);
  const [content, setContent] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [editorKey, setEditorKey] = useState(0);
  const [subject, setSubject] = useState("");
  const [result, setResult] = useState({
    valid_customers: [],
    invalid_customers: [],
  });
  const [recipientsModalOpen, setRecipientsModalOpen] = useState(false);
  const [recipientsData, setRecipientsData] = useState({
    valid_customers: [],
    invalid_customers: [],
  });
  const [isCheckingRecipients, setIsCheckingRecipients] = useState(false);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleCheckBoxChange = (event) => {
    setIsChecked(event.target.checked);
  };
  const [selectedCustomer, setSelectedCustomer] = useState({
    label: "",
    value: "",
  });
  const [selectedCustomerExclude, setSelectedCustomerExclude] = useState({
    label: "",
    value: "",
  });
  const handleFileChange = (event) => {
    dispatch({
      type: REDUCER_ACTIONS.ADD_FILE,
      payload: event.target.files,
    });
  };

  const [customersList, setCustomersList] = useState([]);
  const [customersListExclude, setCustomersListExclude] = useState([]);
  const [correspondanceType, setCorrespondanceType] = useState({
    value: "SELECTED",
    label: "Selected accounts",
  });
  const [limitationsType, setLimitationsType] = useState({
    value: null,
    label: "NONE",
  });
  const [accountTypes, setAccountTypes] = useState([]);
  const [territory, setTerritory] = useState({
    value: null,
    label: "All Territories",
  });
  const CORRESPONDANCE_TYPES = [
    {
      value: "ALL",
      label: "all accounts",
    },
    {
      value: "SELECTED",
      label: "selected accounts",
    },
    {
      value: "3MONTHS",
      label: "ordered 3 months",
    },
    {
      value: "ATYPE",
      label: "Account Type",
    },
  ];
  const LIMITATIONS_TYPES = [
    {
      value: null,
      label: "NONE",
    },
    {
      value: "3MONTHS",
      label: "ordered 3 months",
    },
  ]
  console.log(selectedCustomer);
  const handleEditorChange = (content, editor) => {
    setContent(content);
  };

  function handleSimulateRecipients() {
    const customersArray = data.customers_list.map(
      (customer) => customer.value
    );
    const excludedCustomersArray = data.excluded_customers_list.map(
      (customer) => customer.value
    );
    const payload = new FormData();
    if (correspondanceType == "SELECTED" && customersArray.length == 0) {
      alert("Select at least one account");
      return;
    }
    if (correspondanceType == "ATYPE" && accountTypes.length === 0) {
      alert("Select at least one account type");
      return;
    }
    setIsCheckingRecipients(true);
    setRecipientsModalOpen(true);
    payload.append("correspondance_type", correspondanceType.value);
    payload.append("customers_ids", customersArray);
    payload.append("excluded_customers_ids", excludedCustomersArray);
    payload.append("account_types", accountTypes.map((at) => at.value));
    payload.append("territory", territory.value);
    payload.append("limitations_type", limitationsType.value);
    if (subject) {
      payload.append("subject", subject);
    }
    payload.append("content", content);
    if (data.email_files) {
      for (let i = 0; i < data.email_files.length; i++) {
        let file = data.email_files[i];
        payload.append(`attachments.${i}`, file, file.name);
        console.log("attaching ", file, file.name);
      }
    }
    simulateRecipients(payload)
      .then((res) => {
        setRecipientsData({
          valid_customers: res.data.valid_customers || [],
          invalid_customers: res.data.invalid_customers || [],
        });
      })
      .catch((err) => {
        console.error(err);
        setSnackbarMessage("Failed to check recipients.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        setRecipientsModalOpen(false);
      })
      .finally(() => {
        setIsCheckingRecipients(false);
      });
  }
  function handleEmailSend() {
    setIsSending(true);
    const customersArray = data.customers_list.map(
      (customer) => customer.value
    );
    const excludedCustomersArray = data.excluded_customers_list.map(
      (customer) => customer.value
    );
    const payload = new FormData();
    if (correspondanceType == "SELECTED" && customersArray.length == 0) {
      alert("Select at least one account");
      setIsSending(false);
      return;
    }
    if (correspondanceType == "ATYPE" && accountTypes.length === 0) {
      alert("Select at least one account type");
      setIsSending(false);
      return;
    }
    payload.append("correspondance_type", correspondanceType.value);
    payload.append("customers_ids", customersArray);
    payload.append("excluded_customers_ids", excludedCustomersArray);
    payload.append("account_types", accountTypes.map((at) => at.value));
    payload.append("territory", territory.value);
    payload.append("limitations_type", limitationsType.value);
    if (subject) {
      payload.append("subject", subject);
    }
    payload.append("content", content);
    if (data.email_files) {
      for (let i = 0; i < data.email_files.length; i++) {
        let file = data.email_files[i];
        payload.append(`attachments.${i}`, file, file.name);
        console.log("attaching ", file, file.name);
      }
    }
    for (let [key, value] of payload.entries()) {
      console.log(`${key}: ${value}`);
    }
    console.log("payload is: ", payload);
    sendEmail(payload)
      .then((res) => {
        setResult({
          valid_customers: res.data.valid_customers,
          invalid_customers: res.data.invalid_customers,
        });
        setIsSending(false);
        setContent("");
        setSnackbarMessage("Email sent successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        setSubject("");
        setEditorKey((prevKey) => prevKey + 1);
      })
      .catch((err) => {
        setIsSending(false);
        setContent("");
        setSnackbarMessage("Failed to send email.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        setSubject("");
        setEditorKey((prevKey) => prevKey + 1);
      });
  }

  return (
    <>
      {result.invalid_customers.length > 0 && (
        <>
          <Alert color="error" sx={{ mb: 1 }}>
            Couldn't email following customers (no emails on file):{" "}
            {result.invalid_customers.join(", ")}
          </Alert>
          <Alert color="error" sx={{ mb: 1 }}>
            Couldn't email {result.invalid_customers.length} customers (no
            emails on file)
          </Alert>
        </>
      )}
      {result.valid_customers.length > 0 && (
        <Alert color="success" sx={{ mb: 1 }}>
          Emailing: {result.valid_customers.length} customers
        </Alert>
      )}
      <Typography
        fontSize="23px"
        fontWeight={800}
        component="h2"
        data-testid="page-title"
        mb="10px"
      >
        Email Correspondence
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: "5px",
        }}
      >
        <TextField
          fullWidth
          sx={{ width: "75%" }}
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          placeholder="Email Subject..."
        />
        <Stack direction="row" spacing={1}>
        <Button
          variant="contained"
          color="success"
          onClick={handleEmailSend}
          disabled={isSending}
        >
          Send Email
        </Button>
        <Button onClick={handleSimulateRecipients} variant='contained'>Check Recipients</Button>
        </Stack>
        
      </Box>
      <Grid container spacing={1}>
        <Grid item xs={9}>
          <Editor
            key={editorKey}
            apiKey="gpr4nec4hr3fdzfph9jv42wv8eh6qdn41p2gneq5h7kq8cpy"
            initialValue=""
            init={{
              height: 500,
              menubar: false,
              plugins: [
                "advlist autolink lists link image charmap print preview anchor",
                "searchreplace visualblocks code fullscreen",
                "insertdatetime media table paste code help wordcount",
              ],
              toolbar:
                "undo redo | formatselect | " +
                "bold italic backcolor | alignleft aligncenter " +
                "alignright alignjustify | bullist numlist outdent indent | " +
                "removeformat | help",
            }}
            onEditorChange={handleEditorChange}
          />
          <Block sx={{ mt: "20px" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "20px",
              }}
            >
              <Typography sx={{ fontSize: "20px", fontWeight: "bolder" }}>
                Attachment Files
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Button variant="contained" color="warning" component="label">
                  Upload Files
                  <input type="file" hidden onChange={handleFileChange} />
                </Button>
              </Box>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              {data?.email_files.map((file) => {
                return <AttachmentComponent file={file} dispatch={dispatch} />;
              })}
            </Box>
          </Block>
        </Grid>
        <Grid item xs={3}>
          <Block>
            <Typography>Correspondance type</Typography>
            <Autocomplete
              options={CORRESPONDANCE_TYPES}
              value={correspondanceType}
              onChange={(e, v) => {
                setCorrespondanceType(v);
              }}
              renderInput={(params) => (
                <TextField {...params} label="Correspondance type" />
              )}
            />
          </Block>
          {correspondanceType.value!='3MONTHS' && (
          <Block>
            <Typography>Restriction</Typography>
            <Autocomplete
              options={LIMITATIONS_TYPES}
              value={limitationsType}
              onChange={(e, v) => {
                setLimitationsType(v);
              }}
              renderInput={(params) => (
                <TextField {...params} label="Restriction" />
              )}
            />
          </Block>
          )}
          <Block>
            <Typography>Territory</Typography>
            <TerritorySelect
              value={territory}
              onChange={(e, v) => setTerritory(v)}
            />
          </Block>
          {correspondanceType.value == "SELECTED" && (
            <Block>
              <Typography
                fontSize="18px"
                fontWeight={600}
                component="h2"
                data-testid="page-title"
              >
                Accounts List:
                {data?.customers_list.length > 0 && (
                  <span
                    style={{
                      fontWeight: 400,
                      fontSize: "10px",
                      marginLeft: "5px",
                    }}
                  >
                    ({data.customers_list.length} account(s) selected)
                  </span>
                )}
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  mb: "20px",
                }}
              >
                <AccountSelect
                  label="Add an account"
                  name="account"
                  required
                  customersList={data?.customers_list}
                  disabled={isChecked}
                  value={selectedCustomer}
                  onChange={(_e, newValue) => setSelectedCustomer(newValue)}
                  extraStyles={{
                    mt: 1,
                  }}
                />

                <Button
                  sx={{
                    padding: "4px 5px",
                    fontSize: "12px",
                    minWidth: "0",
                    width: "30px",
                    height: "30px !important",
                    mt: "7px",
                  }}
                  variant="contained"
                  disabled={isChecked}
                  onClick={() => {
                    dispatch({
                      type: REDUCER_ACTIONS.ADD_CUSTOMER,
                      payload: { newCustomer: selectedCustomer },
                    });
                    setSelectedCustomer({ label: "", value: "" });
                  }}
                  color="primary"
                >
                  <AddIcon />
                </Button>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                }}
              >
                {data.customers_list.map((customer) => {
                  return (
                    <CustomerCard
                      customer={customer}
                      setCustomersList={setCustomersList}
                      dispatch={dispatch}
                    />
                  );
                })}
              </Box>
            </Block>
          )}
          {correspondanceType.value == "ATYPE" && (
            <Block>
              <Typography
                fontSize="18px"
                fontWeight={600}
                component="h2"
                data-testid="page-title"
              >
                Account Types
              </Typography>
              <AccountTypeSelect
                label="Account Types"
                name="account_types"
                required={true}
                multiple
                value={accountTypes}
                onChange={(_e, newValue) => setAccountTypes(newValue)}
              />
            </Block>
          )}
          {(correspondanceType.value == "ALL" ||
            correspondanceType.value == "3MONTHS" ||
            correspondanceType.value == "ATYPE") && (
            <Block>
              <Typography
                fontSize="18px"
                fontWeight={600}
                component="h2"
                data-testid="page-title"
              >
                Excluded Accounts List:
                {data?.excluded_customers_list.length > 0 && (
                  <span
                    style={{
                      fontWeight: 400,
                      fontSize: "10px",
                      marginLeft: "5px",
                    }}
                  >
                    ({data.excluded_customers_list.length} account(s) selected)
                  </span>
                )}
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  mb: "20px",
                }}
              >
                <AccountSelect
                  label="Exclude an account"
                  name="account"
                  required
                  customersList={data?.excluded_customers_list}
                  disabled={isChecked}
                  value={selectedCustomerExclude}
                  onChange={(_e, newValue) =>
                    setSelectedCustomerExclude(newValue)
                  }
                  extraStyles={{
                    mt: 1,
                  }}
                />

                <Button
                  sx={{
                    padding: "4px 5px",
                    fontSize: "12px",
                    minWidth: "0",
                    width: "30px",
                    height: "30px !important",
                    mt: "7px",
                  }}
                  variant="contained"
                  disabled={isChecked}
                  onClick={() => {
                    dispatch({
                      type: REDUCER_ACTIONS.ADD_EXCLUDED_CUSTOMER,
                      payload: { newCustomer: selectedCustomerExclude },
                    });
                    setSelectedCustomerExclude({ label: "", value: "" });
                  }}
                  color="primary"
                >
                  <AddIcon />
                </Button>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                }}
              >
                {data.excluded_customers_list.map((customer) => {
                  return (
                    <CustomerCard
                      customer={customer}
                      setCustomersList={setCustomersListExclude}
                      dispatch={dispatch}
                      exclude={true}
                    />
                  );
                })}
              </Box>
            </Block>
          )}
        </Grid>
      </Grid>
      {/* Recipients Check Modal */}
      <Dialog
        open={recipientsModalOpen}
        onClose={() => setRecipientsModalOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 2 },
        }}
      >
        <DialogTitle
          sx={{
            pb: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6" fontWeight={600}>
            Recipients Preview
          </Typography>
          {!isCheckingRecipients && (
            <Chip
              label={`${recipientsData.valid_customers.length + recipientsData.invalid_customers.length} total`}
              size="small"
              color="default"
            />
          )}
        </DialogTitle>
        <DialogContent dividers>
          {isCheckingRecipients ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                py: 4,
              }}
            >
              <CircularProgress size={40} />
              <Typography sx={{ mt: 2 }} color="text.secondary">
                Checking recipients...
              </Typography>
            </Box>
          ) : (
            <Stack spacing={3}>
              {/* Valid Recipients */}
              <Box>
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={1}
                  sx={{ mb: 1.5 }}
                >
                  <CheckCircleOutlineIcon color="success" fontSize="small" />
                  <Typography variant="subtitle1" fontWeight={600}>
                    Valid Recipients
                  </Typography>
                  <Chip
                    label={recipientsData.valid_customers.length}
                    size="small"
                    color="success"
                    variant="outlined"
                  />
                </Stack>
                {recipientsData.valid_customers.length > 0 ? (
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 0.75,
                      maxHeight: 200,
                      overflowY: "auto",
                      p: 1.5,
                      bgcolor: "success.50",
                      borderRadius: 1,
                      border: "1px solid",
                      borderColor: "success.200",
                    }}
                  >
                    {recipientsData.valid_customers.map((customer, index) => (
                      <Chip
                        key={index}
                        label={customer}
                        size="small"
                        sx={{
                          bgcolor: "success.100",
                          color: "success.800",
                          fontWeight: 500,
                        }}
                      />
                    ))}
                  </Box>
                ) : (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontStyle: "italic" }}
                  >
                    No valid recipients found
                  </Typography>
                )}
              </Box>

              {/* Invalid Recipients */}
              {recipientsData.invalid_customers.length > 0 && (
                <>
                  <Divider />
                  <Box>
                    <Stack
                      direction="row"
                      alignItems="center"
                      spacing={1}
                      sx={{ mb: 1.5 }}
                    >
                      <ErrorOutlineIcon color="error" fontSize="small" />
                      <Typography variant="subtitle1" fontWeight={600}>
                        Invalid Recipients
                      </Typography>
                      <Chip
                        label={recipientsData.invalid_customers.length}
                        size="small"
                        color="error"
                        variant="outlined"
                      />
                    </Stack>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mb: 1 }}
                    >
                      These customers have no email on file:
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 0.75,
                        maxHeight: 150,
                        overflowY: "auto",
                        p: 1.5,
                        bgcolor: "error.50",
                        borderRadius: 1,
                        border: "1px solid",
                        borderColor: "error.200",
                      }}
                    >
                      {recipientsData.invalid_customers.map((customer, index) => (
                        <Chip
                          key={index}
                          label={customer}
                          size="small"
                          sx={{
                            bgcolor: "error.100",
                            color: "error.800",
                            fontWeight: 500,
                          }}
                        />
                      ))}
                    </Box>
                  </Box>
                </>
              )}
            </Stack>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button onClick={() => setRecipientsModalOpen(false)} color="inherit">
            Close
          </Button>
          
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}
